/** Draft schedule times: stored/displayed as Eastern wall clock; server uses UTC. */

const EASTERN_TZ = "America/New_York";

function getTimeZoneOffsetMs(timeZone, date) {
  const utc = new Date(date.toLocaleString("en-US", { timeZone: "UTC" }));
  const zoned = new Date(date.toLocaleString("en-US", { timeZone }));
  return zoned.getTime() - utc.getTime();
}

/** Parse YYYY-MM-DD and HH:MM as America/New_York wall clock. */
export function parseEasternWallClock(draftDate, draftTime) {
  if (!draftDate || !draftTime) return null;
  const [year, month, day] = draftDate.split("-").map(Number);
  const [hour, minute] = draftTime.split(":").map((v) => parseInt(v, 10));
  const utcGuess = new Date(Date.UTC(year, month - 1, day, hour, minute));
  const offset = getTimeZoneOffsetMs(EASTERN_TZ, utcGuess);
  return new Date(utcGuess.getTime() - offset);
}

export function getScheduledDraftStart(draftInfo) {
  if (!draftInfo) return null;
  if (draftInfo.scheduled_start_time_utc) {
    const d = new Date(draftInfo.scheduled_start_time_utc);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (draftInfo.draft_scheduled && draftInfo.draft_date && draftInfo.draft_time) {
    return parseEasternWallClock(draftInfo.draft_date, draftInfo.draft_time);
  }
  return null;
}

export function getScheduledLobbyOpen(draftInfo) {
  if (!draftInfo) return null;
  if (draftInfo.lobby_open_time_utc) {
    const d = new Date(draftInfo.lobby_open_time_utc);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const start = getScheduledDraftStart(draftInfo);
  if (!start) return null;
  return new Date(start.getTime() - 30 * 60 * 1000);
}

export function formatDraftTimeEastern(draftDate, draftTime) {
  const dt = parseEasternWallClock(draftDate, draftTime);
  if (!dt) return "";
  return dt.toLocaleString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: EASTERN_TZ,
    timeZoneName: "short",
  });
}

export function formatDraftTimeFromInfo(draftInfo) {
  if (!draftInfo?.draft_date || !draftInfo?.draft_time) return "";
  return formatDraftTimeEastern(draftInfo.draft_date, draftInfo.draft_time);
}
